import React, { useContext } from 'react';
import slugify from 'slugify';
import styled from 'styled-components';
import { UserContext } from '../../../../context/UserContext';
import { variables } from '../../../utils';
import AdminSwitch from './AdminSwitch';
import RemoveMemberButton from './RemoveMemberButton';
import { Badge } from '../../../ui';
import { GroupRoleType } from '../../../../__generated__/globalTypes';

const MemberListItem: any = styled.li.attrs({
  className: 'f6 pv2 bt b--light-gray flex items-center justify-between'
})`
  color: ${(p: any) => (p.member.role === 'PENDING' ? variables.moonGray : variables.navy)};
`;

interface MemberList {
  group: {
    id: string;
  };
  groupMembers: {
    id: string;
    roleType: string;
    member: {
      id: string;
      displayName: string;
      user: {
        id: string;
        email: string;
      };
    };
    membershipStatus: string;
  }[];
  userIsAdmin: boolean;
}

const MemberList: React.FC<MemberList> = ({ group, groupMembers, userIsAdmin }) => {
  const { user } = useContext(UserContext);

  return (
    <div className="bt b--light-gray">
      <p className="f7 tr mv2 fw5">Admin</p>

      <ul className="list ma0 pa0" data-testid="group-members-list">
        {groupMembers.map(groupMember => {
          const { member } = groupMember;
          return (
            <MemberListItem
              member={member}
              key={member.id}
              data-testid={`member-${slugify(member.displayName)}`}
            >
              <div className="flex items-center">
                {userIsAdmin && user.id !== member.user.id && (
                  <div className="mr1">
                    <RemoveMemberButton group={group} member={member} />
                  </div>
                )}
                <span className="mr1">{member.displayName || member.user.email}</span>
                {groupMember.membershipStatus === 'PENDING' && (
                  <Badge className="ml1" data-testid="pending">
                    Pending
                  </Badge>
                )}
              </div>

              <AdminSwitch
                member={groupMember}
                group={group}
                disabled={!userIsAdmin || user.id === member.user.id}
              />
            </MemberListItem>
          );
        })}
      </ul>
    </div>
  );
};

export default MemberList;
